import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { nuevoExpediente } from '../../actions/expedientes'
import '../../css/AltaCliente.css'
import Spinner from '../layout/Spinner'

const optionsEstados = [
  { value: 'TH', label: 'TAILANDIA', name: 'pais' },
  { value: 'TW', label: 'TAIWÁN (PROVINCIA DE CHINA)', name: 'pais' },
  { value: 'TZ', label: 'TANZANIA, REPÚBLICA UNIDA DE', name: 'pais' },
  { value: 'TJ', label: 'TAYIKISTÁN', name: 'pais' },
  { value: 'IO', label: 'TERRITORIO BRITÁNICO DEL OCÉANO ÍNDICO', name: 'pais' },
  { value: 'TF', label: 'TIERRAS AUSTRALES FRANCESAS (LAS)', name: 'pais' },
  { value: 'TL', label: 'TIMOR-LESTE', name: 'pais' },
  { value: 'TG', label: 'TOGO', name: 'pais' },
  { value: 'TK', label: 'TOKELAU', name: 'pais' },
  { value: 'TO', label: 'TONGA', name: 'pais' },
  { value: 'TT', label: 'TRINIDAD Y TABAGO', name: 'pais' },
  { value: 'TN', label: 'TÚNEZ', name: 'pais' },
  { value: 'TM', label: 'TURKMENISTÁN', name: 'pais' },
  { value: 'TR', label: 'TURQUÍA', name: 'pais' },
  { value: 'TV', label: 'TUVALU', name: 'pais' },
  { value: 'UA', label: 'UCRANIA', name: 'pais' },
  { value: 'UG', label: 'UGANDA', name: 'pais' },
  { value: 'UY', label: 'URUGUAY', name: 'pais' },
  { value: 'UZ', label: 'UZBEKISTÁN', name: 'pais' },
  { value: 'VU', label: 'VANUATU', name: 'pais' },
  { value: 'VA', label: 'SANTA SEDE (LA)', name: 'pais' },
  { value: 'VE', label: 'VENEZUELA (REPÚBLICA BOLIVARIANA DE)', name: 'pais' },
  { value: 'VN', label: 'VIET NAM', name: 'pais' },
  { value: 'WF', label: 'WALLIS Y FUTUNA', name: 'pais' },
  { value: 'YE', label: 'YEMEN', name: 'pais' },
  { value: 'DJ', label: 'DJIBOUTI', name: 'pais' },
  { value: 'ZM', label: 'ZAMBIA', name: 'pais' },
  { value: 'ZW', label: 'ZIMBABWE', name: 'pais' },
  { value: 'DE', label: 'ALEMANIA', name: 'pais' },
  { value: 'AT', label: 'AUSTRIA', name: 'pais' },
  { value: 'BE', label: 'BÉLGICA', name: 'pais' },
  { value: 'BG', label: 'BULGARIA', name: 'pais' },
  { value: 'CY', label: 'CHIPRE', name: 'pais' },
  { value: 'HR', label: 'CROACIA', name: 'pais' },
  { value: 'DK', label: 'DINAMARCA', name: 'pais' },
  { value: 'SK', label: 'ESLOVAQUIA', name: 'pais' },
  { value: 'SI', label: 'ESLOVENIA', name: 'pais' },
  { value: 'ES', label: 'ESPAÑA', name: 'pais' },
  { value: 'EE', label: 'ESTONIA', name: 'pais' },
  { value: 'FI', label: 'FINLANDIA', name: 'pais' },
  { value: 'FR', label: 'FRANCIA', name: 'pais' },
  { value: 'GR', label: 'GRECIA', name: 'pais' },
  { value: 'HU', label: 'HUNGRÍA', name: 'pais' },
  { value: 'IE', label: 'IRLANDA', name: 'pais' },
  { value: 'IT', label: 'ITALIA', name: 'pais' },
  { value: 'LV', label: 'LETONIA', name: 'pais' },
  { value: 'LT', label: 'LITUANIA', name: 'pais' },
  { value: 'LU', label: 'LUXEMBURGO', name: 'pais' },
  { value: 'MT', label: 'MALTA', name: 'pais' },
  { value: 'NL', label: 'PAÍSES BAJOS (LOS)', name: 'pais' },
  { value: 'PL', label: 'POLONIA', name: 'pais' },
  { value: 'PT', label: 'PORTUGAL', name: 'pais' },
  { value: 'GB', label: 'GRAN BRETAÑA ', name: 'pais' },
  { value: 'CZ', label: 'REPÚBLICA CHECA', name: 'pais' },
  { value: 'RO', label: 'RUMANIA', name: 'pais' },
  { value: 'SE', label: 'SUECIA', name: 'pais' },
  { value: 'AF', label: 'AFGANISTÁN', name: 'pais' },
  { value: 'AX', label: 'ÅLAND, ISLAS', name: 'pais' },
  { value: 'AL', label: 'ALBANIA', name: 'pais' },
  { value: 'AD', label: 'ANDORRA', name: 'pais' },
  { value: 'AO', label: 'ANGOLA', name: 'pais' },
  { value: 'AI', label: 'ANGUILA', name: 'pais' },
  { value: 'AQ', label: 'ANTÁRTIDA', name: 'pais' },
  { value: 'AG', label: 'ANTIGUA Y BARBUDA', name: 'pais' },
  { value: 'SA', label: 'ARABIA SAUDITA', name: 'pais' },
  { value: 'DZ', label: 'ARGELIA', name: 'pais' },
  { value: 'AR', label: 'ARGENTINA', name: 'pais' },
  { value: 'AM', label: 'ARMENIA', name: 'pais' },
  { value: 'AW', label: 'ARUBA', name: 'pais' },
  { value: 'AU', label: 'AUSTRALIA', name: 'pais' },
  { value: 'AZ', label: 'AZERBAIYÁN', name: 'pais' },
  { value: 'BS', label: 'BAHAMAS (LAS)', name: 'pais' },
  { value: 'BD', label: 'BANGLADESH', name: 'pais' },
  { value: 'BB', label: 'BARBADOS', name: 'pais' },
  { value: 'BH', label: 'BAHREIN', name: 'pais' },
  { value: 'BZ', label: 'BELICE', name: 'pais' },
  { value: 'BJ', label: 'BENIN', name: 'pais' },
  { value: 'BM', label: 'BERMUDAS', name: 'pais' },
  { value: 'BY', label: 'BELARÚS', name: 'pais' },
  { value: 'BO', label: 'BOLIVIA ', name: 'pais' },
  { value: 'BQ', label: 'BONAIRE, SAN EUSTAQUIO Y SABA', name: 'pais' },
  { value: 'BA', label: 'BOSNIA Y HERZEGOVINA', name: 'pais' },
  { value: 'BW', label: 'BOTSWANA', name: 'pais' },
  { value: 'BR', label: 'BRASIL', name: 'pais' },
  { value: 'BN', label: 'BRUNEI DARUSSALAM', name: 'pais' },
  { value: 'BF', label: 'BURKINA FASO', name: 'pais' },
  { value: 'BI', label: 'BURUNDI', name: 'pais' },
  { value: 'BT', label: 'BHUTÁN', name: 'pais' },
  { value: 'CV', label: 'CABO VERDE', name: 'pais' },
  { value: 'KH', label: 'CAMBOYA', name: 'pais' },
  { value: 'CM', label: 'CAMERÚN', name: 'pais' },
  { value: 'CA', label: 'CANADÁ', name: 'pais' },
  { value: 'QA', label: 'QATAR', name: 'pais' },
  { value: 'TD', label: 'CHAD', name: 'pais' },
  { value: 'CL', label: 'CHILE', name: 'pais' },
  { value: 'CN', label: 'CHINA', name: 'pais' },
  { value: 'CO', label: 'COLOMBIA', name: 'pais' },
  { value: 'KM', label: 'COMORAS (LAS)', name: 'pais' },
  { value: 'KP', label: 'COREA (REPÚBLICA POPULAR DEMOCRÁTICA)', name: 'pais' },
  { value: 'KR', label: 'COREA (LA REPÚBLICA DE)', name: 'pais' },
  { value: 'CI', label: "CÔTE D'IVOIRE", name: 'pais' },
  { value: 'CR', label: 'COSTA RICA', name: 'pais' },
  { value: 'CU', label: 'CUBA', name: 'pais' },
  { value: 'CW', label: 'CURAÇAO', name: 'pais' },
  { value: 'DM', label: 'DOMINICA', name: 'pais' },
  { value: 'EC', label: 'ECUADOR', name: 'pais' },
  { value: 'EG', label: 'EGIPTO', name: 'pais' },
  { value: 'SV', label: 'EL SALVADOR', name: 'pais' },
  { value: 'AE', label: 'EMIRATOS ÁRABES UNIDOS', name: 'pais' },
  { value: 'ER', label: 'ERITREA', name: 'pais' },
  { value: 'US', label: 'ESTADOS UNIDOS DE AMÉRICA', name: 'pais' },
  { value: 'ET', label: 'ETIOPÍA', name: 'pais' },
  { value: 'PH', label: 'FILIPINAS', name: 'pais' },
  { value: 'FJ', label: 'FIJI', name: 'pais' },
  { value: 'GA', label: 'GABÓN', name: 'pais' },
  { value: 'GM', label: 'GAMBIA', name: 'pais' },
  { value: 'GE', label: 'GEORGIA', name: 'pais' },
  { value: 'GH', label: 'GHANA', name: 'pais' },
  { value: 'GI', label: 'GIBRALTAR', name: 'pais' },
  { value: 'GD', label: 'GRANADA', name: 'pais' },
  { value: 'GL', label: 'GROENLANDIA', name: 'pais' },
  { value: 'GP', label: 'GUADELOUPE', name: 'pais' },
  { value: 'GU', label: 'GUAM', name: 'pais' },
  { value: 'GT', label: 'GUATEMALA', name: 'pais' },
  { value: 'GF', label: 'GUAYANA FRANCESA', name: 'pais' },
  { value: 'GG', label: 'GUERNSEY', name: 'pais' },
  { value: 'GN', label: 'GUINEA', name: 'pais' },
  { value: 'GW', label: 'GUINEA BISSAU', name: 'pais' },
  { value: 'GQ', label: 'GUINEA ECUATORIAL', name: 'pais' },
  { value: 'GY', label: 'GUYANA', name: 'pais' },
  { value: 'HT', label: 'HAITÍ', name: 'pais' },
  { value: 'HN', label: 'HONDURAS', name: 'pais' },
  { value: 'HK', label: 'HONG KONG', name: 'pais' },
  { value: 'IN', label: 'INDIA', name: 'pais' },
  { value: 'ID', label: 'INDONESIA', name: 'pais' },
  { value: 'IQ', label: 'IRAQ', name: 'pais' },
  { value: 'IR', label: 'IRÁN', name: 'pais' },
  { value: 'BV', label: 'BOUVET, ISLA', name: 'pais' },
  { value: 'IM', label: 'ISLA DE MAN', name: 'pais' },
  { value: 'CX', label: 'NAVIDAD, ISLA DE', name: 'pais' },
  { value: 'IS', label: 'ISLANDIA', name: 'pais' },
  { value: 'WS', label: 'SAMOA', name: 'pais' },
  { value: 'AS', label: 'SAMOA AMERICANA', name: 'pais' },
  { value: 'BL', label: 'SAINT BARTHÉLEMY', name: 'pais' },
  { value: 'KN', label: 'SAINT KITTS Y NEVIS', name: 'pais' },
  { value: 'SM', label: 'SAN MARINO', name: 'pais' },
  { value: 'MF', label: 'SAINT MARTIN (PARTE FRANCESA)', name: 'pais' },
  { value: 'PM', label: 'SAN PEDRO Y MIQUELÓN', name: 'pais' },
  { value: 'VC', label: 'SAN VICENTE Y LAS GRANADINAS', name: 'pais' },
  { value: 'SH', label: 'SANTA HELENA, ASCENSIÓN Y TRISTÁN ACUÑA', name: 'pais' },
  { value: 'LC', label: 'SANTA LUCÍA', name: 'pais' },
  { value: 'ST', label: 'SANTO TOMÉ Y PRÍNCIPE', name: 'pais' },
  { value: 'SN', label: 'SENEGAL', name: 'pais' },
  { value: 'RS', label: 'SERBIA', name: 'pais' },
  { value: 'SC', label: 'SEYCHELLES', name: 'pais' },
  { value: 'SL', label: 'SIERRA LEONA', name: 'pais' },
  { value: 'SG', label: 'SINGAPUR', name: 'pais' },
  { value: 'SX', label: 'SINT MAARTEN (PARTE NEERLANDESA)', name: 'pais' },
  { value: 'SY', label: 'REPÚBLICA ÁRABE SIRIA', name: 'pais' },
  { value: 'SO', label: 'SOMALIA', name: 'pais' },
  { value: 'LK', label: 'SRI LANKA', name: 'pais' },
  { value: 'SZ', label: 'SWAZILANDIA', name: 'pais' },
  { value: 'ZA', label: 'SUDÁFRICA', name: 'pais' },
  { value: 'SD', label: 'SUDÁN (EL)', name: 'pais' },
  { value: 'SS', label: 'SUDÁN DEL SUR', name: 'pais' },
  { value: 'CH', label: 'SUIZA', name: 'pais' },
  { value: 'SR', label: 'SURINAME', name: 'pais' },
  { value: 'SJ', label: 'SVALBARD Y JAN MAYEN', name: 'pais' },
  { value: 'KY', label: 'CAIMÁN, (LAS) ISLAS', name: 'pais' },
  { value: 'CC', label: 'COCOS / KEELING, (LAS) ISLAS', name: 'pais' },
  { value: 'CK', label: 'COOK, (LAS) ISLAS', name: 'pais' },
  { value: 'FO', label: 'FEROE, (LAS) ISLAS', name: 'pais' },
  { value: 'GS', label: 'GEORGIA DEL SUR Y ISLAS SANDWICH DEL SUR', name: 'pais' },
  { value: 'HM', label: 'HEARD (ISLA) E ISLAS MCDONALD', name: 'pais' },
  { value: 'FK', label: 'MALVINAS [FALKLAND], ISLAS', name: 'pais' },
  { value: 'MP', label: 'MARIANAS DEL NORTE, ISLAS', name: 'pais' },
  { value: 'MH', label: 'MARSHALL, ISLAS', name: 'pais' },
  { value: 'PN', label: 'PITCAIRN', name: 'pais' },
  { value: 'SB', label: 'SALOMÓN, ISLAS', name: 'pais' },
  { value: 'TC', label: 'TURCAS Y CAICOS, (LAS) ISLAS', name: 'pais' },
  { value: 'VG', label: 'VÍRGENES BRITÁNICAS, ISLAS', name: 'pais' },
  { value: 'VI', label: 'VÍRGENES DE LOS paisS UNIDOS, ISLAS', name: 'pais' },
  { value: 'IL', label: 'ISRAEL', name: 'pais' },
  { value: 'JM', label: 'JAMAICA', name: 'pais' },
  { value: 'JP', label: 'JAPÓN', name: 'pais' },
  { value: 'JE', label: 'JERSEY', name: 'pais' },
  { value: 'JO', label: 'JORDANIA', name: 'pais' },
  { value: 'KZ', label: 'KAZAJSTÁN', name: 'pais' },
  { value: 'KE', label: 'KENYA', name: 'pais' },
  { value: 'KG', label: 'KIRGUISTÁN', name: 'pais' },
  { value: 'KI', label: 'KIRIBATI', name: 'pais' },
  { value: 'KW', label: 'KUWAIT', name: 'pais' },
  { value: 'LA', label: 'LAO, (LA) REPÚBLICA DEMOCRÁTICA POPULAR', name: 'pais' },
  { value: 'LS', label: 'LESOTHO', name: 'pais' },
  { value: 'LB', label: 'LÍBANO', name: 'pais' },
  { value: 'LR', label: 'LIBERIA', name: 'pais' },
  { value: 'LY', label: 'LIBIA', name: 'pais' },
  { value: 'LI', label: 'LIECHTENSTEIN', name: 'pais' },
  { value: 'MO', label: 'MACAO', name: 'pais' },
  { value: 'MK', label: 'MACEDONIA', name: 'pais' },
  { value: 'MG', label: 'MADAGASCAR', name: 'pais' },
  { value: 'MY', label: 'MALASIA', name: 'pais' },
  { value: 'MW', label: 'MALAWI', name: 'pais' },
  { value: 'MV', label: 'MALDIVAS', name: 'pais' },
  { value: 'ML', label: 'MALÍ', name: 'pais' },
  { value: 'MA', label: 'MARRUECOS', name: 'pais' },
  { value: 'MQ', label: 'MARTINIQUE', name: 'pais' },
  { value: 'MU', label: 'MAURICIO', name: 'pais' },
  { value: 'MR', label: 'MAURITANIA', name: 'pais' },
  { value: 'YT', label: 'MAYOTTE', name: 'pais' },
  { value: 'MX', label: 'MÉXICO', name: 'pais' },
  { value: 'FM', label: 'MICRONESIA (ESTADOS FEDERADOS DE)', name: 'pais' },
  { value: 'MD', label: 'MOLDOVA', name: 'pais' },
  { value: 'MC', label: 'MÓNACO', name: 'pais' },
  { value: 'MN', label: 'MONGOLIA', name: 'pais' },
  { value: 'ME', label: 'MONTENEGRO', name: 'pais' },
  { value: 'MS', label: 'MONTSERRAT', name: 'pais' },
  { value: 'MZ', label: 'MOZAMBIQUE', name: 'pais' },
  { value: 'MM', label: 'MYANMAR', name: 'pais' },
  { value: 'NA', label: 'NAMIBIA', name: 'pais' },
  { value: 'NR', label: 'NAURU', name: 'pais' },
  { value: 'NP', label: 'NEPAL', name: 'pais' },
  { value: 'NI', label: 'NICARAGUA', name: 'pais' },
  { value: 'NE', label: 'NÍGER (EL)', name: 'pais' },
  { value: 'NG', label: 'NIGERIA', name: 'pais' },
  { value: 'NU', label: 'NIUE', name: 'pais' },
  { value: 'NF', label: 'NORFOLK, ISLA', name: 'pais' },
  { value: 'NO', label: 'NORUEGA', name: 'pais' },
  { value: 'NC', label: 'NUEVA CALEDONIA', name: 'pais' },
  { value: 'NZ', label: 'NUEVA ZELANDIA', name: 'pais' },
  { value: 'OM', label: 'OMÁN', name: 'pais' },
  { value: 'PK', label: 'PAKISTÁN', name: 'pais' },
  { value: 'PW', label: 'PALAU', name: 'pais' },
  { value: 'PS', label: 'PALESTINA, ESTADO DE', name: 'pais' },
  { value: 'PA', label: 'PANAMÁ', name: 'pais' },
  { value: 'PG', label: 'PAPUA NUEVA GUINEA', name: 'pais' },
  { value: 'PY', label: 'PARAGUAY', name: 'pais' },
  { value: 'PE', label: 'PERÚ', name: 'pais' },
  { value: 'PF', label: 'POLINESIA FRANCESA', name: 'pais' },
  { value: 'PR', label: 'PUERTO RICO', name: 'pais' },
  { value: 'EH', label: 'SAHARA OCCIDENTAL', name: 'pais' },
  { value: 'CF', label: 'REPÚBLICA CENTROAFRICANA', name: 'pais' },
  { value: 'CG', label: 'CONGO', name: 'pais' },
  { value: 'CD', label: 'CONGO (REPÚBLICA DEMOCRÁTICA DEL)', name: 'pais' },
  { value: 'DO', label: 'DOMINICANA', name: 'pais' },
  { value: 'RE', label: 'REUNIÓN', name: 'pais' },
  { value: 'RW', label: 'RWANDA', name: 'pais' },
  { value: 'RU', label: 'RUSIA, (LA) FEDERACIÓN DE', name: 'pais' },
]

const optionsProvincias = [
  { value: '02', label: 'ALBACETE', estado: 'ES' },
  { value: '03', label: 'ALICANTE/ALACANT', estado: 'ES' },
  { value: '04', label: 'ALMERÍA', estado: 'ES' },
  { value: '01', label: 'ARABA/ÁLAVA', estado: 'ES' },
  { value: '33', label: 'ASTURIAS', estado: 'ES' },
  { value: '05', label: 'ÁVILA', estado: 'ES' },
  { value: '06', label: 'BADAJOZ', estado: 'ES' },
  { value: '07', label: 'BALEARS, ILLES', estado: 'ES' },
  { value: '08', label: 'BARCELONA', estado: 'ES' },
  { value: '48', label: 'BIZKAIA', estado: 'ES' },
  { value: '09', label: 'BURGOS', estado: 'ES' },
  { value: '10', label: 'CÁCERES', estado: 'ES' },
  { value: '11', label: 'CÁDIZ', estado: 'ES' },
  { value: '39', label: 'CANTABRIA', estado: 'ES' },
  { value: '12', label: 'CASTELLÓN/CASTELLÓ', estado: 'ES' },
  { value: '13', label: 'CIUDAD REAL', estado: 'ES' },
  { value: '14', label: 'CÓRDOBA', estado: 'ES' },
  { value: '15', label: 'CORUÑA, A', estado: 'ES' },
  { value: '16', label: 'CUENCA', estado: 'ES' },
  { value: '20', label: 'GIPUZKOA', estado: 'ES' },
  { value: '17', label: 'GIRONA', estado: 'ES' },
  { value: '18', label: 'GRANADA', estado: 'ES' },
  { value: '19', label: 'GUADALAJARA', estado: 'ES' },
  { value: '21', label: 'HUELVA', estado: 'ES' },
  { value: '22', label: 'HUESCA', estado: 'ES' },
  { value: '23', label: 'JAÉN', estado: 'ES' },
  { value: '24', label: 'LEÓN', estado: 'ES' },
  { value: '25', label: 'LLEIDA', estado: 'ES' },
  { value: '27', label: 'LUGO', estado: 'ES' },
  { value: '28', label: 'MADRID', estado: 'ES' },
  { value: '29', label: 'MÁLAGA', estado: 'ES' },
  { value: '30', label: 'MURCIA', estado: 'ES' },
  { value: '31', label: 'NAVARRA', estado: 'ES' },
  { value: '32', label: 'OURENSE', estado: 'ES' },
  { value: '34', label: 'PALENCIA', estado: 'ES' },
  { value: '35', label: 'PALMAS, LAS', estado: 'ES' },
  { value: '36', label: 'PONTEVEDRA', estado: 'ES' },
  { value: '26', label: 'RIOJA, LA', estado: 'ES' },
  { value: '37', label: 'SALAMANCA', estado: 'ES' },
  { value: '38', label: 'SANTA CRUZ DE TENERIFE', estado: 'ES' },
  { value: '40', label: 'SEGOVIA', estado: 'ES' },
  { value: '41', label: 'SEVILLA', estado: 'ES' },
  { value: '42', label: 'SORIA', estado: 'ES' },
  { value: '43', label: 'TARRAGONA', estado: 'ES' },
  { value: '44', label: 'TERUEL', estado: 'ES' },
  { value: '45', label: 'TOLEDO', estado: 'ES' },
  { value: '46', label: 'VALENCIA/VALÈNCIA', estado: 'ES' },
  { value: '47', label: 'VALLADOLID', estado: 'ES' },
  { value: '49', label: 'ZAMORA', estado: 'ES' },
  { value: '50', label: 'ZARAGOZA', estado: 'ES' },
  { value: '51', label: 'CEUTA', estado: 'ES' },
  { value: '52', label: 'MELILLA', estado: 'ES' },
  { value: '00', label: 'Para importación NO USAR', estado: 'ES' },
  { value: '0', label: '.', estado: 'TZ' },
  { value: '0', label: '.', estado: 'FJ' },
  { value: '0', label: '.', estado: 'AX' },
  { value: '0', label: '.', estado: 'CF' },
  { value: '0', label: '.', estado: 'RE' },
  { value: '0', label: '.', estado: 'BS' },
  { value: '0', label: '.', estado: 'IM' },
  { value: '0', label: '.', estado: 'MW' },
  { value: '0', label: '.', estado: 'GL' },
  { value: '0', label: '.', estado: 'TC' },
  { value: '0', label: '.', estado: 'IO' },
  { value: '0', label: '.', estado: 'TM' },
  { value: '0', label: '.', estado: 'MM' },
  { value: '0', label: '.', estado: 'GY' },
  { value: '0', label: '.', estado: 'UG' },
  { value: '0', label: '.', estado: 'MF' },
  { value: '0', label: '.', estado: 'AS' },
  { value: '0', label: '.', estado: 'IQ' },
  { value: '0', label: '.', estado: 'AG' },
  { value: '0', label: '.', estado: 'GM' },
  { value: '0', label: '.', estado: 'MO' },
  { value: '0', label: '.', estado: 'ZM' },
  { value: '0', label: '.', estado: 'AW' },
  { value: '0', label: '.', estado: 'GU' },
  { value: '0', label: '.', estado: 'MG' },
  { value: '0', label: '.', estado: 'WF' },
  { value: '0', label: '.', estado: 'RW' },
  { value: '0', label: '.', estado: 'MC' },
  { value: '0', label: '.', estado: 'GT' },
  { value: '0', label: '.', estado: 'LS' },
  { value: '0', label: '.', estado: 'MZ' },
  { value: '0', label: '.', estado: 'ST' },
  { value: '0', label: '.', estado: 'TK' },
  { value: '0', label: '.', estado: 'VU' },
  { value: '0', label: '.', estado: 'BL' },
  { value: '0', label: '.', estado: 'KE' },
  { value: '0', label: '.', estado: 'BW' },
  { value: '0', label: '.', estado: 'NR' },
  { value: '0', label: '.', estado: 'CG' },
  { value: '0', label: '.', estado: 'TJ' },
  { value: '0', label: '.', estado: 'AQ' },
  { value: '0', label: '.', estado: 'BV' },
  { value: '0', label: '.', estado: 'GS' },
  { value: '0', label: '.', estado: 'KI' },
  { value: '0', label: '.', estado: 'MS' },
  { value: '0', label: '.', estado: 'BI' },
  { value: '0', label: '.', estado: 'FM' },
  { value: '0', label: '.', estado: 'ID' },
  { value: '0', label: '.', estado: 'KP' },
  { value: '0', label: '.', estado: 'BN' },
  { value: '0', label: '.', estado: 'JM' },
  { value: '0', label: '.', estado: 'SS' },
  { value: '0', label: '.', estado: 'SJ' },
  { value: '0', label: '.', estado: 'BD' },
  { value: '0', label: '.', estado: 'HT' },
  { value: '0', label: '.', estado: 'LK' },
  { value: '0', label: '.', estado: 'LR' },
  { value: '0', label: '.', estado: 'MU' },
  { value: '0', label: '.', estado: 'AF' },
  { value: '0', label: '.', estado: 'GP' },
  { value: '0', label: '.', estado: 'TG' },
  { value: '0', label: '.', estado: 'MY' },
  { value: '0', label: '.', estado: 'VI' },
  { value: '0', label: '.', estado: 'KY' },
  { value: '0', label: '.', estado: 'BQ' },
  { value: '0', label: '.', estado: 'NF' },
  { value: '0', label: '.', estado: 'TW' },
  { value: '0', label: '.', estado: 'ML' },
  { value: '0', label: '.', estado: 'LC' },
  { value: '0', label: '.', estado: 'SX' },
  { value: '0', label: '.', estado: 'KM' },
  { value: '0', label: '.', estado: 'SC' },
  { value: '0', label: '.', estado: 'VC' },
  { value: '0', label: '.', estado: 'JE' },
  { value: '0', label: '.', estado: 'ME' },
  { value: '0', label: '.', estado: 'PN' },
  { value: '0', label: '.', estado: 'EH' },
  { value: '0', label: '.', estado: 'GN' },
  { value: '0', label: '.', estado: 'BM' },
  { value: '0', label: '.', estado: 'KH' },
  { value: '0', label: '.', estado: 'YT' },
  { value: '0', label: '.', estado: 'PM' },
  { value: '0', label: '.', estado: 'BJ' },
  { value: '0', label: '.', estado: 'TV' },
  { value: '0', label: '.', estado: 'TO' },
  { value: '0', label: '.', estado: 'PY' },
  { value: '0', label: '.', estado: 'CX' },
  { value: '0', label: '.', estado: 'SR' },
  { value: '0', label: '.', estado: 'VA' },
  { value: '0', label: '.', estado: 'PR' },
  { value: '0', label: '.', estado: 'CW' },
  { value: '0', label: '.', estado: 'SV' },
  { value: '0', label: '.', estado: 'NP' },
  { value: '0', label: '.', estado: 'CK' },
  { value: '0', label: '.', estado: 'CV' },
  { value: '0', label: '.', estado: 'TT' },
  { value: '0', label: '.', estado: 'TL' },
  { value: '0', label: '.', estado: 'SM' },
  { value: '0', label: '.', estado: 'GH' },
  { value: '0', label: '.', estado: 'AO' },
  { value: '0', label: '.', estado: 'TF' },
  { value: '0', label: '.', estado: 'NE' },
  { value: '0', label: '.', estado: 'SL' },
  { value: '0', label: '.', estado: 'YE' },
  { value: '0', label: '.', estado: 'MQ' },
  { value: '0', label: '.', estado: 'ZW' },
  { value: '0', label: '.', estado: 'ER' },
  { value: '0', label: '.', estado: 'GF' },
  { value: '0', label: '.', estado: 'FK' },
  { value: '0', label: '.', estado: 'SD' },
  { value: '0', label: '.', estado: 'PW' },
  { value: '0', label: '.', estado: 'WS' },
  { value: '0', label: '.', estado: 'KN' },
  { value: '0', label: '.', estado: 'BZ' },
  { value: '0', label: '.', estado: 'DM' },
  { value: '0', label: '.', estado: 'KR' },
  { value: '0', label: '.', estado: 'BB' },
  { value: '0', label: '.', estado: 'CC' },
  { value: '0', label: '.', estado: 'MP' },
  { value: '0', label: '.', estado: 'LI' },
  { value: '0', label: '.', estado: 'MV' },
  { value: '0', label: '.', estado: 'AI' },
  { value: '0', label: '.', estado: 'TD' },
  { value: '0', label: '.', estado: 'SO' },
  { value: '0', label: '.', estado: 'GD' },
  { value: '0', label: '.', estado: 'NU' },
  { value: '0', label: '.', estado: 'VG' },
  { value: '0', label: '.', estado: 'BF' },
  { value: '0', label: '.', estado: 'LA' },
  { value: '0', label: '.', estado: 'GG' },
  { value: '0', label: '.', estado: 'SH' },
  { value: '0', label: '.', estado: 'BT' },
  { value: '0', label: '.', estado: 'CD' },
  { value: '0', label: '.', estado: 'FO' },
  { value: '0', label: '.', estado: 'HM' },
  { value: '0', label: '.', estado: 'MH' },
  { value: '0', label: '.', estado: 'PG' },
  { value: '0', label: '.', estado: 'CM' },
  { value: '0', label: '.', estado: 'NI' },
  { value: '0', label: '.', estado: 'SZ' },
  { value: '0', label: '.', estado: 'SB' },
  { value: '0', label: '.', estado: 'NA' },
  { value: '0', label: '.', estado: 'GA' },
  { value: '0', label: '.', estado: 'VN' },
  { value: '01', label: '.', estado: 'AD' },
  { value: '01', label: '.', estado: 'AE' },
  { value: '01', label: '.', estado: 'AL' },
  { value: '01', label: '.', estado: 'AM' },
  { value: '01', label: '.', estado: 'AR' },
  { value: '01', label: '.', estado: 'AT' },
  { value: '01', label: '.', estado: 'AU' },
  { value: '01', label: '.', estado: 'AZ' },
  { value: '01', label: '.', estado: 'BA' },
  { value: '01', label: '.', estado: 'BE' },
  { value: '01', label: '.', estado: 'BG' },
  { value: '01', label: '.', estado: 'BH' },
  { value: '01', label: '.', estado: 'BO' },
  { value: '01', label: '.', estado: 'BR' },
  { value: '01', label: '.', estado: 'BY' },
  { value: '01', label: '.', estado: 'CA' },
  { value: '01', label: '.', estado: 'CH' },
  { value: '01', label: '.', estado: 'CI' },
  { value: '01', label: '.', estado: 'CL' },
  { value: '01', label: '.', estado: 'CN' },
  { value: '01', label: '.', estado: 'CO' },
  { value: '01', label: '.', estado: 'CR' },
  { value: '01', label: '.', estado: 'CU' },
  { value: '01', label: '.', estado: 'CY' },
  { value: '01', label: '.', estado: 'CZ' },
  { value: '01', label: '.', estado: 'DE' },
  { value: '01', label: '.', estado: 'DJ' },
  { value: '01', label: '.', estado: 'DK' },
  { value: '01', label: '.', estado: 'DO' },
  { value: '01', label: '.', estado: 'DZ' },
  { value: '01', label: '.', estado: 'EC' },
  { value: '01', label: '.', estado: 'EE' },
  { value: '01', label: '.', estado: 'EG' },
  { value: '01', label: '.', estado: 'ET' },
  { value: '01', label: '.', estado: 'FI' },
  { value: '01', label: '.', estado: 'FR' },
  { value: '01', label: '.', estado: 'GB' },
  { value: '01', label: '.', estado: 'GE' },
  { value: '01', label: '.', estado: 'GI' },
  { value: '01', label: '.', estado: 'GQ' },
  { value: '01', label: '.', estado: 'GR' },
  { value: '01', label: '.', estado: 'GW' },
  { value: '01', label: '.', estado: 'HK' },
  { value: '01', label: '.', estado: 'HN' },
  { value: '01', label: '.', estado: 'HR' },
  { value: '01', label: '.', estado: 'HU' },
  { value: '01', label: '.', estado: 'IE' },
  { value: '01', label: '.', estado: 'IL' },
  { value: '01', label: '.', estado: 'IN' },
  { value: '01', label: '.', estado: 'IR' },
  { value: '01', label: '.', estado: 'IS' },
  { value: '01', label: '.', estado: 'IT' },
  { value: '01', label: '.', estado: 'JO' },
  { value: '01', label: '.', estado: 'JP' },
  { value: '01', label: '.', estado: 'KG' },
  { value: '01', label: '.', estado: 'KW' },
  { value: '01', label: '.', estado: 'KZ' },
  { value: '01', label: '.', estado: 'LB' },
  { value: '01', label: '.', estado: 'LT' },
  { value: '01', label: '.', estado: 'LU' },
  { value: '01', label: '.', estado: 'LV' },
  { value: '01', label: '.', estado: 'LY' },
  { value: '01', label: '.', estado: 'MA' },
  { value: '01', label: '.', estado: 'MD' },
  { value: '01', label: '.', estado: 'MK' },
  { value: '01', label: '.', estado: 'MN' },
  { value: '01', label: '.', estado: 'MR' },
  { value: '01', label: '.', estado: 'MT' },
  { value: '01', label: '.', estado: 'MX' },
  { value: '01', label: '.', estado: 'NC' },
  { value: '01', label: '.', estado: 'NG' },
  { value: '01', label: '.', estado: 'NL' },
  { value: '01', label: '.', estado: 'NO' },
  { value: '01', label: '.', estado: 'NZ' },
  { value: '01', label: '.', estado: 'OM' },
  { value: '01', label: '.', estado: 'PA' },
  { value: '01', label: '.', estado: 'PE' },
  { value: '01', label: '.', estado: 'PF' },
  { value: '01', label: '.', estado: 'PH' },
  { value: '01', label: '.', estado: 'PK' },
  { value: '01', label: '.', estado: 'PL' },
  { value: '01', label: '.', estado: 'PS' },
  { value: '01', label: '.', estado: 'PT' },
  { value: '01', label: '.', estado: 'QA' },
  { value: '01', label: '.', estado: 'RO' },
  { value: '01', label: '.', estado: 'RS' },
  { value: '01', label: '.', estado: 'RU' },
  { value: '01', label: '.', estado: 'SA' },
  { value: '01', label: '.', estado: 'SE' },
  { value: '01', label: '.', estado: 'SG' },
  { value: '01', label: '.', estado: 'SI' },
  { value: '01', label: '.', estado: 'SK' },
  { value: '01', label: '.', estado: 'SN' },
  { value: '01', label: '.', estado: 'SY' },
  { value: '01', label: '.', estado: 'TH' },
  { value: '01', label: '.', estado: 'TN' },
  { value: '01', label: '.', estado: 'TR' },
  { value: '01', label: '.', estado: 'UA' },
  { value: '01', label: '.', estado: 'US' },
  { value: '01', label: '.', estado: 'UY' },
  { value: '01', label: '.', estado: 'UZ' },
  { value: '01', label: '.', estado: 'VE' },
  { value: '01', label: '.', estado: 'ZA' },
]

const optionsTipoEmpresa = [
  { value: 'MA', label: 'Mayorista', name: 'tipo_empresa' },
  { value: 'MI', label: 'Minorista', name: 'tipo_empresa' },
  { value: 'PO', label: 'Profesional', name: 'tipo_empresa' },
  { value: 'OT', label: 'Otros', name: 'tipo_empresa' },
]

const optionsCantiEmpresa = [
  { value: '001', label: '1-3', name: 'canti_empresa' },
  { value: '002', label: '4-6', name: 'canti_empresa' },
  { value: '003', label: '7-10', name: 'canti_empresa' },
  { value: '004', label: '+10', name: 'canti_empresa' },
]

const optionsCargo = [
  { value: '1', label: 'Compras', name: 'cargo' },
  { value: '2', label: 'Contabilidad', name: 'cargo' },
  { value: '3', label: 'Administrador/gerente', name: 'cargo' },
  { value: '4', label: 'Marketing', name: 'cargo' },
]

const AltaCliente = () => {
  const dispatch = useDispatch()

  const isLoading = useSelector(state => state.expedientes.isLoading)

  const [valores, setValores] = useState({
    tipo_empresa: '',
    canti_empresa: '',
    razon_social: '',
    cif: '',
    contacto_empresa: '',
    subir: '',
    direccion: '',
    poblacion: '',
    codigo_postal: '',
    provincia: '',
    pais: '',
    usar_dir_fiscal: false,
    direccion_envio: '',
    poblacion_envio: '',
    codigo_postal_envio: '',
    provincia_envio: '',
    pais_envio: '',
    horario_entrega: '',
    contacto: '',
    contacto2: '',
    telefono: '',
    telefono2: '',
    movil: '',
    movil2: '',
    email1: '',
    email2: '',
    web: '',
    banco: '',
    forma_pago_general: '',
    forma_pago: '',
    iban: 'ES',
    num1: '',
    num2: '',
    num3: '',
    num4: '',
    num5: '',
    contrareembolso: 'S',
    recargo: '',
    observaciones: '',
    cargo1: '',
    cargo2: '',
    promotions: false,
  })

  const [provinciasFiltradas, setProvinciasFiltradas] = useState(optionsProvincias)
  const [provinciasEnvioFiltradas, setProvinciasEnvioFiltradas] = useState(optionsProvincias)

  useEffect(() => {
    let aux_prov = optionsProvincias.filter(provincia => provincia.estado === valores.pais)
    if (valores.pais) {
      setProvinciasFiltradas(aux_prov)
      if (aux_prov.length === 1) {
        setValores({ ...valores, ['provincia']: aux_prov[0].value })
      } else {
        setValores({ ...valores, ['provincia']: '' })
      }
    }
  }, [valores.pais])

  useEffect(() => {
    if (!valores.usar_dir_fiscal) {
      let aux_prov_env = optionsProvincias.filter(
        provincia => provincia.estado === valores.pais_envio,
      )
      if (valores.pais_envio) {
        setProvinciasEnvioFiltradas(aux_prov_env)
        if (aux_prov_env.length === 1) {
          setValores({ ...valores, ['provincia_envio']: aux_prov_env[0].value })
        } else {
          setValores({ ...valores, ['provincia_envio']: '' })
        }
      }
    }
  }, [valores.pais_envio])

  useEffect(() => {
    if (valores.usar_dir_fiscal) {
      setValores({
        ...valores,
        ['direccion_envio']: valores.direccion,
        ['pais_envio']: valores.pais,
        ['provincia_envio']: valores.provincia,
        ['poblacion_envio']: valores.poblacion,
        ['codigo_postal_envio']: valores.codigo_postal,
      })
    } else {
      setValores({
        ...valores,
        ['direccion_envio']: '',
        ['pais_envio']: '',
        ['provincia_envio']: '',
        ['poblacion_envio']: '',
        ['codigo_postal_envio']: '',
      })
    }
  }, [valores.usar_dir_fiscal])

  const [files, setFiles] = useState({
    filesAux: [],
    fileInput: React.createRef(),
  })

  const readFile = file => {
    return new Promise(function (resolve, reject) {
      let fr = new FileReader()

      fr.onload = function () {
        resolve(fr.result)
      }

      fr.onerror = function () {
        reject(fr)
      }

      fr.readAsBinaryString(file)
    })
  }

  const onSelectFile = e => {
    if (files.fileInput?.current?.files?.length > 0) {
      setFiles({ ...files, filesAux: files.fileInput.current.files })
    }
  }

  const handleCheckBoxChange = event => {
    const { name, checked } = event.target
    setValores({
      ...valores,
      [name]: checked,
    })
  }

  const handleInputChange = event => {
    const { name, value } = event.target
    setValores({
      ...valores,
      [name]: value,
    })
  }

  const handleSelectChange = e => {
    setValores({
      ...valores,
      [e.name]: e.value,
    })
  }

  const handleSelectPaisChange = e => {
    setValores({
      ...valores,
      ['pais']: e.value,
    })
  }

  const handleSelectCargo1Change = e => {
    setValores({
      ...valores,
      ['cargo1']: e.value,
    })
  }

  const handleSelectCargo2Change = e => {
    setValores({
      ...valores,
      ['cargo2']: e.value,
    })
  }

  const handleSelectPaisEnvioChange = e => {
    setValores({
      ...valores,
      ['pais_envio']: e.value,
    })
  }

  const handleSelectProvinciaChange = e => {
    setValores({
      ...valores,
      ['provincia']: e.value,
    })
  }

  const handleSelectProvinciaEnvioChange = e => {
    setValores({
      ...valores,
      ['provincia_envio']: e.value,
    })
  }

  const handleForm = event => {
    event.preventDefault()
    console.log(valores)

    let altaCliente = {
      tipo_expediente: 'ALTA_CLIENTE',
      descripcion_expediente1: valores.razon_social,
      itema001: valores.tipo_empresa,
      itema002: valores.canti_empresa,
      itema003: valores.razon_social,
      itema004: valores.cif,
      itema005: valores.contacto_empresa,
      itema006: valores.direccion,
      itema007: valores.poblacion,
      itema008: valores.codigo_postal,
      itema009: valores.provincia,
      itema010: valores.pais,
      itema011: valores.direccion_envio,
      itema012: valores.poblacion_envio,
      itema013: valores.codigo_postal_envio,
      itema014: valores.provincia_envio,
      itema015: valores.pais_envio,
      itema016: valores.telefono,
      itema017: valores.telefono2,
      itema018: valores.movil,
      itema019: valores.contacto,
      itema020: valores.movil2,
      itema021: valores.contacto2,
      itema022: valores.email2,
      itema023: valores.email1,
      itema024: valores.web,
      itema025: valores.banco,
      itema026:
        valores.iban + valores.num1 + valores.num2 + valores.num3 + valores.num4 + valores.num5,
      itema027: valores.forma_pago,
      itema028: valores.recargo,
      itema029: valores.horario_entrega,
      itema032: valores.cargo1,
      itema033: valores.cargo2,
      reservado_check01: valores.usar_dir_fiscal ? 'S' : 'N',
      reservado_check02: valores.contrareembolso,
      reservado_check03: valores.promotions ? 'S' : 'N',
      comentarios: valores.observaciones,
    }

    let readers = []
    let fileArray = []

    if (files.filesAux) {
      for (let index = 0; index < files.filesAux?.length; index++) {
        let selectedFile = files.filesAux?.item(index)
        if (selectedFile) {
          readers.push(readFile(selectedFile))
        }
      }
      Promise.all(readers).then(values => {
        for (let index = 0; index < files.filesAux.length; index++) {
          let selectedFile = files.filesAux.item(index)
          if (selectedFile) {
            let fileName = selectedFile?.name
            let fileType = selectedFile?.type
            let contenido = btoa(values[index])
            fileArray.push({
              nombre: fileName,
              tipo: fileType,
              contenido: contenido,
            })
          }
        }

        altaCliente['ficheros'] = fileArray?.length > 0 ? fileArray : []

        //Convertimos las keys a minusculas para evitar problemas en el back
        let val_aux = Object.keys(altaCliente)
        val_aux.map(valor => {
          let val_aux_Upper = valor // Nombre campo original (Puede estar en mayusculas)
          let val_aux_Lower = val_aux_Upper.toLowerCase() // Nombre campo minusculas
          if (val_aux_Upper !== val_aux_Lower) {
            Object.defineProperty(
              altaCliente,
              val_aux_Lower,
              Object.getOwnPropertyDescriptor(altaCliente, val_aux_Upper),
            )
            delete altaCliente[val_aux_Upper]
          }
          return altaCliente
        })
        //Enviamos datos
        dispatch(nuevoExpediente(altaCliente))
        // Limpiamos estado local
        setValores({
          tipo_empresa: '',
          canti_empresa: '',
          razon_social: '',
          cif: '',
          contacto_empresa: '',
          subir: '',
          direccion: '',
          poblacion: '',
          codigo_postal: '',
          provincia: '',
          pais: '',
          usar_dir_fiscal: false,
          direccion_envio: '',
          poblacion_envio: '',
          codigo_postal_envio: '',
          provincia_envio: '',
          pais_envio: '',
          horario_entrega: '',
          contacto: '',
          contacto2: '',
          telefono: '',
          telefono2: '',
          movil: '',
          movil2: '',
          email1: '',
          email2: '',
          web: '',
          banco: '',
          forma_pago_general: '',
          forma_pago: '',
          iban: 'ES',
          num1: '',
          num2: '',
          num3: '',
          num4: '',
          num5: '',
          contrareembolso: 'S',
          recargo: '',
          observaciones: '',
          cargo1: '',
          cargo2: '',
          promotions: false,
        })
        //Limpiamos datos ficheros
        setFiles({ filesAux: [], fileInput: React.createRef() })
      })
    }
  }

  if (isLoading) {
    return <Spinner showSpinner={true} />
  } else {
    return (
      <form
        className='container'
        onSubmit={handleForm}>
        <div className='titulo text-center p-3'>
          <h2>Alta de nuevos clientes</h2>
        </div>
        <h5>
          Complete este formulario y sus datos serán enviados a <strong>Industrias Oriol</strong>{' '}
          para su valoración y proceder al alta de cliente.
        </h5>
        <h6>Datos de empresa</h6>
        <div className='row'>
          <div className='col mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='razon_social'>
              Razón social*:
            </label>
            <input
              id='razon_social'
              name='razon_social'
              value={valores.razon_social}
              type='text'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>

          <div className='col mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='cif'>
              CIF*:
            </label>
            <input
              id='cif'
              name='cif'
              type='text'
              value={valores.cif}
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='contacto_empresa'>
            Contacto*:
          </label>
          <input
            id='contacto_empresa'
            name='contacto_empresa'
            value={valores.contacto_empresa}
            type='text'
            className='form-control'
            onChange={handleInputChange}
            required={true}
          />
        </div>

        <div className='row mb-3'>
          <div className='col'>
            <label
              className='form-control-label px-3'
              htmlFor='tipo_empresa'>
              Tipo de empresa:
            </label>
            <Select
              className='form-select'
              id={'tipo_empresa'}
              defaultValue={valores.tipo_empresa}
              options={optionsTipoEmpresa}
              onChange={handleSelectChange}
            />
          </div>
        </div>

        <div className='row mb-5'>
          <div className='col'>
            <label
              className='form-control-label px-3'
              htmlFor='canti_empresa'>
              Número de trabajadores:
            </label>
            <Select
              className='form-select'
              id={'canti_empresa'}
              defaultValue={valores.canti_empresa}
              options={optionsCantiEmpresa}
              onChange={handleSelectChange}
            />
          </div>
        </div>

        <h6>Documentación</h6>
        <div className='form-group mb-5'>
          <label className='form-control-label px-3 font-weight-bold'>
            Por favor, a continuación adjunte el documento{' '}
            <a
              href='https://proveswebclient.ioriol.com/assets/img/036.pdf'
              download='036.pdf'>
              036
            </a>{' '}
            o{' '}
            <a
              href='https://proveswebclient.ioriol.com/assets/img/037.pdf'
              download='037.pdf'>
              037
            </a>
            *:
          </label>
          <input
            id='subir'
            ref={files.fileInput}
            name='subir'
            accept='application/pdf'
            multiple={false}
            type='file'
            className='form-control'
            onChange={ev => {
              onSelectFile(ev.nativeEvent.target)
            }}
            required={true}
          />
        </div>

        <h6>Dirección fiscal</h6>
        <div className='row mb-3'>
          <div className='col-12 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='direccion'>
              Dirección*:
            </label>
            <input
              id='direccion'
              name='direccion'
              value={valores.direccion}
              type='text'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='pais'>
              País*:
            </label>
            <Select
              className='form-select'
              id={'pais'}
              required={true}
              defaultValue={valores.pais}
              options={optionsEstados}
              onChange={handleSelectPaisChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='provincia'>
              Provincia*:
            </label>
            <Select
              className='form-select'
              id={'provincia'}
              required={true}
              options={provinciasFiltradas}
              onChange={handleSelectProvinciaChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='poblacion'>
              Población*:
            </label>
            <input
              id='poblacion'
              name='poblacion'
              value={valores.poblacion}
              type='text'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='codigo_postal'>
              Código postal*:
            </label>
            <input
              id='codigo_postal'
              name='codigo_postal'
              value={valores.codigo_postal}
              type='text'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
        </div>

        <h6>Envío</h6>
        <div className='px-3 mb-3'>
          <div className='form-check'>
            <input
              id='usar_dir_fiscal'
              name='usar_dir_fiscal'
              type='checkbox'
              checked={valores.usar_dir_fiscal}
              className={
                valores.usar_dir_fiscal ? 'form-check-input checked' : 'form-check-input unchecked'
              }
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label'
              htmlFor='usar_dir_fiscal'>
              Usar dirección fiscal:
            </label>
          </div>
        </div>

        <div
          className='row mb-3'
          hidden={valores.usar_dir_fiscal}>
          <div className='col-12 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='direccion_envio'>
              Dirección:
            </label>
            <input
              id='direccion_envio'
              name='direccion_envio'
              value={valores.direccion_envio}
              type='text'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='pais_envio'>
              País:
            </label>
            <Select
              className='form-select'
              id={'pais_envio'}
              defaultValue={valores.pais_envio}
              options={optionsEstados}
              onChange={handleSelectPaisEnvioChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='provincia_envio'>
              Provincia:
            </label>
            <Select
              className='form-select'
              id={'provincia_envio'}
              defaultValue={valores.provincia_envio}
              options={provinciasEnvioFiltradas}
              onChange={handleSelectProvinciaEnvioChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='poblacion_envio'>
              Población:
            </label>
            <input
              id='poblacion_envio'
              name='poblacion_envio'
              value={valores.poblacion_envio}
              type='text'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-4 mb-3'>
            <label
              className='form-control-label px-3'
              htmlFor='codigo_postal_envio'>
              Código postal:
            </label>
            <input
              id='codigo_postal_envio'
              name='codigo_postal_envio'
              value={valores.codigo_postal_envio}
              type='text'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className='row mb-5'>
          <div className='col-2'>
            <label
              className='form-control-label px-3'
              htmlFor='horario_entrega'>
              Horario de entrega:
            </label>
            <input
              id='horario_entrega'
              name='horario_entrega'
              value={valores.horario_entrega}
              type='text'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
        </div>

        <h6>Teléfono / Emails / Web</h6>
        <div className='row mb-3'>
          <div className='col-6'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='contacto'>
              Nombre contacto 1*:
            </label>
            <input
              id='contacto'
              name='contacto'
              value={valores.contacto}
              type='text'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='telefono'>
              Teléfono 1*:
            </label>
            <input
              id='telefono'
              name='telefono'
              value={valores.telefono}
              type='number'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='movil'>
              Móvil 1*:
            </label>
            <input
              id='movil'
              name='movil'
              value={valores.movil}
              type='number'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
              required={true}
            />
          </div>
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='email1'>
            Email 1*:
          </label>
          <input
            id='email1'
            name='email1'
            value={valores.email1}
            type='email'
            className='form-control'
            onChange={handleInputChange}
            required={true}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3 font-weight-bold'
            htmlFor='cargo1'>
            Cargo 1*:
          </label>
          <Select
            className='form-select'
            id={'cargo1'}
            required={true}
            defaultValue={valores.cargo1}
            options={optionsCargo}
            onChange={handleSelectCargo1Change}
          />
        </div>

        <div className='row mb-3'>
          <div className='col-6'>
            <label
              className='form-control-label px-3'
              htmlFor='contacto2'>
              Nombre contacto 2:
            </label>
            <input
              id='contacto2'
              name='contacto2'
              value={valores.contacto2}
              type='text'
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3'
              htmlFor='telefono2'>
              Teléfono 2:
            </label>
            <input
              id='telefono2'
              name='telefono2'
              value={valores.telefono2}
              type='number'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-3'>
            <label
              className='form-control-label px-3'
              htmlFor='movil2'>
              Móvil 2:
            </label>
            <input
              id='movil2'
              name='movil2'
              value={valores.movil2}
              type='number'
              className='form-control notNumberArrows'
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3'
            htmlFor='email2'>
            Email 2:
          </label>
          <input
            id='email2'
            name='email2'
            value={valores.email2}
            type='email'
            className='form-control'
            onChange={handleInputChange}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3'
            htmlFor='cargo2'>
            Cargo 2:
          </label>
          <Select
            className='form-select'
            id={'cargo2'}
            required={false}
            defaultValue={valores.cargo2}
            options={optionsCargo}
            onChange={handleSelectCargo2Change}
          />
        </div>

        <div className='form-group'>
          <label
            className='form-control-label px-3'
            htmlFor='web'>
            Página web:
          </label>
          <input
            id='web'
            name='web'
            value={valores.web}
            type='text'
            className='form-control'
            onChange={handleInputChange}
          />
        </div>
        <p className='mb-5'>
          <b>TODAS LAS FACTURAS SERÁN ENVIADAS POR EMAIL AL CORREO ELECTRONICO INDICADO</b>
        </p>

        {/* ¿Es necesario?
		<div className="row px-4 mb-2">
			<label className="form-check-label">Datos bancarios</label>
			<input className="form-check-input" type="radio" name="forma_pago_general" id="forma_pago_general" value={valores.forma_pago_general}  />
		</div>
		*/}

        <h6>Formas de pago</h6>
        <div className='row mb-3'>
          <div className='col-12 mb-3'>
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='banco'>
              Banco*:
            </label>
            <input
              id='banco'
              name='banco'
              value={valores.banco}
              type='text'
              className='form-control'
              onChange={handleInputChange}
              required={true}
            />
          </div>
          <label
            className='form-control-label px-4 font-weight-bold'
            htmlFor='iban'>
            IBAN*:
          </label>
          <div className='col-1'>
            <input
              id='iban'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='iban'
              value={valores.iban}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-1'>
            <input
              id='num1'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num1'
              value={valores.num1}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-1'>
            <input
              id='num2'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num2'
              value={valores.num2}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-1'>
            <input
              id='num3'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num3'
              value={valores.num3}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-1'>
            <input
              id='num4'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num4'
              value={valores.num4}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-1'>
            <input
              id='num5'
              pattern='.{4,4}'
              required={true}
              title='Mínimo de 4 caracteres aceptados'
              name='num5'
              value={valores.num5}
              type='text'
              className='form-control'
              maxLength='4'
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className='form-check form-check-inline'>
          <label className='px-3'>Forma de pago*:</label>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='forma_pago'
              id='forma_pago_10'
              value='001'
              checked={valores.forma_pago === '001'}
              onChange={handleInputChange}
            />
            <label
              className='form-check-label'
              htmlFor='forma_pago_10'>
              Giro bancario a 10 días
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='forma_pago'
              id='forma_pago_30'
              value='002'
              checked={valores.forma_pago === '002'}
              onChange={handleInputChange}
            />
            <label
              className='form-check-label'
              htmlFor='forma_pago_30'>
              Giro bancario a 30 días
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='forma_pago'
              id='forma_pago_60'
              value='003'
              checked={valores.forma_pago === '003'}
              onChange={handleInputChange}
            />
            <label
              className='form-check-label'
              htmlFor='forma_pago_60'>
              Giro bancario a 60 días
            </label>
          </div>
        </div>
        <div className='form-group'>
          <div className='mb-3'>
            <p className='px-3'>
              ** Solicitaremos clasificación a Crédito y Caución (éste trámite puede demorarse de 1
              a 2 semanas aprox.)
            </p>
            <label
              className='form-control-label px-4'
              htmlFor='contrareembolso'>
              Mientras no se tenga esta clasificación se enviará contrareembolso:
            </label>
            <select
              id='contrareembolso'
              name='contrareembolso'
              className='form-control'
              onChange={handleInputChange}>
              <option value='S'>Si</option>
              <option value='N'>No</option>
            </select>
          </div>
          <div className='mb-3'>
            {/* <p className='px-3'>(Este tipo de pago no contará con ningún descuento)</p> */}
            <label
              className='form-control-label px-3 font-weight-bold'
              htmlFor='recargo'>
              Recargo equivalencia*:
            </label>
            <select
              id='recargo'
              name='recargo'
              required={true}
              className='form-control'
              onChange={handleInputChange}>
              <option value=''>Selecciona..</option>
              <option value='S'>Si</option>
              <option value='N'>No</option>
            </select>
          </div>
          <div className='form-group'>
            <label
              className='form-control-label px-3'
              htmlFor='observaciones'>
              Observaciones:
            </label>
            <textarea
              id='observaciones'
              name='observaciones'
              cols='1'
              className='form-control'
              onChange={handleInputChange}></textarea>
          </div>
          <p className='mb-3'>* Campos obligatorios</p>

          <div className='form-check mb-3'>
            <input
              id='promotions'
              className='form-check-input m-1'
              name='promotions'
              type='checkbox'
              checked={valores.promotions}
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label px-4'
              htmlFor='promotions'>
              Acepto recibir información sobre ofertas, promociones o novedades (nosotros seguimos
              la ley de RGPD)
            </label>
          </div>

          <div className='form-check mb-3'>
            <input
              id='condicions'
              className='form-check-input m-1'
              name='condicions'
              type='checkbox'
              required={true}
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label px-4 font-weight-bold'
              htmlFor='condicions'>
              He leido y acepto las condiciones de protección de datos
            </label>
          </div>

          <div className='form-check mb-3'>
            <input
              id='condicionscompra'
              className='form-check-input m-1'
              name='condicionscompra'
              type='checkbox'
              required={true}
              onChange={handleCheckBoxChange}
            />
            <label
              className='form-check-label px-4 font-weight-bold'
              htmlFor='condicionscompra'>
              He leido y acepto las{' '}
              <a
                href='https://altacliente.eurostil.com/img/venta-online.pdf'
                style={{ color: 'darkblue' }}
                target='_blank'>
                condiciones de venta por internet
              </a>{' '}
              a través de los portales de venta on-line
            </label>
          </div>

          <div id='form-group'>
            <p>
              Presto mi consentimiento para que mis datos sean incluidos en un Fichero de
              titularidad del RESPONSABLE, con domicilio en Ciudad de Asunción, 56(Barcelona), donde
              podré dirigirme para ejercer mis derechos de acceso, rectificación, cancelación y
              oposición. Mis datos serán tratados con la finalidad de gestionar los servicios
              requeridos y enviarme información acerca de las actividades del RESPONSABLE.
            </p>
          </div>
          <div className='row justify-content-center'>
            <div className='form-group col-sm-3 p-3'>
              <input
                id='enviar'
                className='btn btn-primary btn-block'
                value='Enviar'
                type='submit'
              />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default AltaCliente
